import { useTranslation } from "react-i18next";

interface LoadingProps {
  /** Custom loading message key for translation */
  messageKey?: string;
  /** Custom minimum height for the container */
  minHeight?: string;
  /** Custom size classes for the spinner */
  spinnerSize?: string;
  /** Whether to show the loading container or just the spinner */
  inline?: boolean;
}

export function Loading({
  messageKey = "common.loading",
  minHeight = "min-h-[300px]",
  spinnerSize = "h-8 w-8",
  inline = false
}: LoadingProps) {
  const { t } = useTranslation();

  const spinner = (
    <div
      className={`animate-spin rounded-full ${spinnerSize} border-t-2 border-b-2 border-primary`}
      title={t(messageKey)}
    />
  );

  if (inline) {
    return spinner;
  }

  return (
    <div className={`flex justify-center items-center ${minHeight}`}>
      {spinner}
    </div>
  );
}
